import { StyleSheet } from 'react-native';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';

export const rewardArtStyles = StyleSheet.create({
  scene: {
    width: '100%',
    alignItems: 'center',
    gap: 16,
  },
  vsCard: {
    width: '100%',
    backgroundColor: ONBOARDING_COLORS.purpleDeep,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.08)',
    paddingHorizontal: 16,
    paddingTop: 18,
    paddingBottom: 16,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.5,
    shadowRadius: 12,
    elevation: 8,
  },
  vsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  vsCol: {
    alignItems: 'center',
    gap: 8,
  },
  vsAvatarWrap: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  vsAvatarImg: {
    width: '100%',
    height: '100%',
  },
  vsPill: {
    borderRadius: 999,
    paddingVertical: 4,
    paddingHorizontal: 16,
    maxWidth: 120,
  },
  vsPillYou: {
    backgroundColor: ONBOARDING_COLORS.purple,
  },
  vsPillYouText: {
    fontSize: 12,
    fontWeight: '800',
    color: ONBOARDING_COLORS.ink,
  },
  vsPillRival: {
    backgroundColor: 'rgba(255,255,255,0.14)',
  },
  vsPillRivalText: {
    fontSize: 12,
    fontWeight: '800',
    color: ONBOARDING_COLORS.textPrimary,
  },
  vsBadge: {
    width: 50,
    height: 50,
    borderRadius: 999,
    backgroundColor: ONBOARDING_COLORS.gold,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    shadowColor: ONBOARDING_COLORS.gold,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.35,
    shadowRadius: 8,
    elevation: 6,
  },
  vsBadgeText: {
    fontSize: 17,
    fontWeight: '800',
    color: '#1A202C',
  },
  vsTagline: {
    marginTop: 12,
    fontSize: 14,
    fontWeight: '700',
    color: ONBOARDING_COLORS.textPrimary,
    textAlign: 'center',
  },
  chipsBlock: {
    width: '100%',
    alignItems: 'center',
  },
  chipsHeader: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 1,
    color: ONBOARDING_COLORS.textSub,
    textAlign: 'center',
    marginBottom: 10,
  },
  chipsWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: 8,
  },
  chip: {
    borderRadius: 999,
    borderWidth: 1,
    paddingVertical: 9,
    paddingHorizontal: 15,
  },
  chipOn: {
    backgroundColor: ONBOARDING_COLORS.purple,
    borderColor: ONBOARDING_COLORS.purple,
  },
  chipOff: {
    backgroundColor: ONBOARDING_COLORS.surface,
    borderColor: ONBOARDING_COLORS.border,
  },
  chipPressed: {
    transform: [{ scale: 0.96 }],
  },
  chipText: {
    fontSize: 13,
    fontWeight: '700',
  },
  chipTextOn: {
    color: ONBOARDING_COLORS.ink,
  },
  chipTextOff: {
    color: ONBOARDING_COLORS.textPrimary,
  },
  footer: {
    fontSize: 13,
    color: ONBOARDING_COLORS.textMuted,
    textAlign: 'center',
    paddingHorizontal: 8,
  },
});
